import { render, staticRenderFns } from "./ConfirmSubmit.vue?vue&type=template&id=1980354c&scoped=true&"
import script from "./ConfirmSubmit.vue?vue&type=script&lang=js&"
export * from "./ConfirmSubmit.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmSubmit.vue?vue&type=style&index=0&id=1980354c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1980354c",
  null
  
)

export default component.exports